export default __webpack_public_path__ + "assets/a3018e94ac1bd91ee734a5aa2e8fa213.png";